import ChecksTable from 'dashboard/components/ChecksTable';
import { Check } from 'dashboard/models/check';
import { sortChecks } from 'lib/utils/checks';

interface DatabaseTinChecksProps {
  checks: Check[];
}

const ChecksTableDatabaseTin = ({ checks }: DatabaseTinChecksProps) => {
  const displayChecks = sortChecks(checks);
  return <>{displayChecks.length > 0 && <ChecksTable checks={displayChecks} />}</>;
};

export default ChecksTableDatabaseTin;
